module.exports = __webpack_public_path__ + "app/img/login-top.372b0be3.png";